import { Grid } from "@mui/material";
import React from "react";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
interface PrivacyPolicyProps {
  close: any;
}
function PrivacyPolicy(props: PrivacyPolicyProps) {
  return (
    <Grid container padding={2}>
      <Grid
        
        width={"100%"}
        display={"flex"}
        justifyContent={"end"}
        position={"sticky"}
        top={0}
        zIndex={1}
      >
        <CloseOutlinedIcon style={{ cursor: "pointer" }} onClick={props.close} />
      </Grid>
      <h2>Privacy Policy</h2>
      <p>
        Service Provider takes privacy protection very seriously and we value the trust you place in
        us. Please read this document regarding our privacy policy. Note: Our privacy policy is
        subject to change time to time without notice. To make sure you are aware of the changes,
        please review this policy periodically. Also, this privacy statement does not apply to our
        business partners, affiliates, or other third parties. Please review the privacy statements
        of the other parties with whom you may interact.
      </p>

      <h3>User or Customer Information We Collect</h3>
      <ul>
        <li>
          Your contact details such as email address, Service Provider account password, phone
          number, and shipping and billing address.
        </li>
        <li>
          Your transaction or banking details such as credit card number, cardholder name,
          expiration date, and CVV or other information as required for internet banking or other
          payment instruments is not held by us.
        </li>
        <li>
          Cookies: Cookies are a piece of data stored by a website within a browser which enables
          the browser to remember information specific to a given user such as clicking particular
          buttons, logging in, or having read certain pages on our site.
        </li>
        <li>
          Your session log information on our site which includes your navigation within the site,
          source of traffic, IP address (from which we can approximately determine user location),
          browser type, browser language, operating system, date and time of request etc.
        </li>
        <li>
          Third party sign-in information shared on our website such as Facebook, Twitter,
          Pinterest, and other sign-in information.
        </li>
        <li>
          Email communication by any user or customer related to product enquiry, order and
          transaction related information, disputes, or complaints etc.
        </li>
      </ul>

      <h3>How We Utilize User or Customer Information</h3>
      <p>
        We only collect user or customer information as required to conduct our business and to
        enable us to provide the best services to our users and customers. We do not sell or rent
        this information to third parties unless agreed to by the user. User or customer information
        may be used as described below:
      </p>
      <ul>
        <li>
          User and customer information may be shared with our subsidiaries, affiliates, and
          partners which are also involved in delivering the service to you as a customer or in your
          buying process.
        </li>
        <li>
          We will also need to share some or all of your information as governed in the case of
          acquisitions by or mergers with other business entities.
        </li>
        <li>
          We may use some of the user and customer information defined above to understand customer
          behavior and thus offer better and more relevant experiences to you.
        </li>
        <li>
          We use certain information in an aggregated form across users to compile statistical and
          demographical profiles for our business and marketing activities.
        </li>
        <li>
          We may use your information to inform you about offers and deals, new launches,
          information about products you have purchased, order and shipping status, as well as other
          promotional and informational content. We will provide you the option to opt-out of such
          services. Cookies shall be used to provide a customized experience to our users such as
          identifying recently viewed items (of interest to the user) as well as implementing wish
          list and cart features.
        </li>
        <li>
          We may use session log and traffic flow information to understand how users are
          interacting with our site and to make improvements. This will also be used by us to
          understand and analyze customer preferences, buying patterns and behaviour at an aggregate
          level.
        </li>
        <li>
          We may use IP address, traffic sources, user navigation across the site, browser and OS
          information etc. to measure overall site performance in terms of number of users, user
          engagement, time spent by users on the site etc. We may need to use information in case
          required in aspects such as legal disputes or other legal processes; comply with any
          statutory or regulatory requirement; troubleshoot problems; detect and protect against
          error, fraud and other criminal or illegal activity; collect fees owed; enforce our terms
          and conditions; prevent abuse of our services; prevent violation of the rights of third
          parties, other users or the general public Service Provider provides all users with the
          opportunity to opt-out of receiving non-essential communications from us on behalf of our
          partners, and from us in general, after setting up an account.
        </li>
      </ul>
      <h3>How do we respond to legal requests or prevent harm? </h3>
      <p>
        We may access, preserve and share your information in response to a legal request (like a
        search warrant, decree or court order) if we have a good faith belief that the law requires
        us to do so. This may include responding to legal requests from jurisdictions outside of the
        India where we have a good faith belief that the response is required by law in that
        jurisdiction, affects users in that jurisdiction, and is consistent with internationally
        recognized standards. We may also access, preserve and share information when we have a good
        faith belief it is necessary to: detect, prevent and address fraud and other illegal
        activity; to protect ourselves, you and others, including as part of investigations; or to
        prevent death or imminent bodily harm. For example, we may provide information to
        third-party partners about the reliability of your account to prevent fraud and abuse on and
        off of our Services. Information we receive about you, including financial transaction data
        related to purchases made with us, may be accessed, processed and retained for an extended
        period of time when it is the subject of a legal request or obligation, governmental
        investigation, or investigations concerning possible violations of our terms or policies, or
        otherwise to prevent harm. We also may retain information from accounts disabled for
        violations of our terms for at least a year to prevent repeat abuse or other violations of
        our terms. We may also use the information in legal cases initiated against us by you or on
        your behalf or any other third party or any other user.
      </p>
    </Grid>
  );
}

export default PrivacyPolicy;
